__turbopack_context__.v({
  "control": "HeroAtmosphere-module__9ZPUMq__control",
  "field": "HeroAtmosphere-module__9ZPUMq__field",
  "layer": "HeroAtmosphere-module__9ZPUMq__layer",
  "poster": "HeroAtmosphere-module__9ZPUMq__poster",
  "tint": "HeroAtmosphere-module__9ZPUMq__tint",
  "video": "HeroAtmosphere-module__9ZPUMq__video",
});
